module.exports = __webpack_public_path__ + "static/media/LossSell.9e4dfc7d.svg";